// Admin copy of the web app's src/Organizer/Oireachtas/countSheet.js (organizer panel, 2026-09-26).
// Keep the two in step; only this header differs.
// Add-on count sheet CSV (Assessments tab): one row per school with the
// quantity of each add-on, plus a totals row. Text cells are made safe for
// spreadsheets: a leading =, +, -, @, tab or CR is neutralised with a quote
// prefix (no formula execution), and cells with a delimiter, quote or line
// break are quoted.
export const csvCell = (v) => {
  let t = String(v);
  if (typeof v === 'string' && /^[=+\-@\t\r]/.test(t)) t = `'${t}`;
  return /[",\r\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
};

export function countSheetCsv(items, rows) {
  const lines = [
    ['School', ...items.map((i) => i.label)],
    ...rows.map((r) => [r.school || '—', ...items.map((i) => r.qty[i.key] || 0)]),
    ['Total', ...items.map((i) => i.qty)],
  ];
  return lines.map((cells) => cells.map(csvCell).join(',')).join('\n') + '\n';
}

// Any table as CSV: a header row then one row per record, same safe cells.
export const tableCsv = (header, rows) => [header, ...rows].map((cells) => cells.map(csvCell).join(',')).join('\n') + '\n';

// Cents as a plain spreadsheet number: 17500 -> "175.00" (no currency sign).
export const csvMoney = (cents) => (Number(cents || 0) / 100).toFixed(2);
